(function () {
  function closeRevTab() {
    var e = document.getElementById('vntg-rev-tab');
    if (e && e.hasAttribute('open')) {
      e.removeAttribute('open');
      e.setAttribute('aria-expanded', 'false');
    }
  }
  // Meerdere momenten proberen zodat thema-JS ons niet overschrijft
  [0, 50, 150, 400].forEach(function (t) { setTimeout(closeRevTab, t); });
  document.addEventListener('DOMContentLoaded', closeRevTab);
  window.addEventListener('load', closeRevTab);
})();
